import { initializeApp } from "firebase/app";
import { doc, setDoc, getFirestore, Timestamp } from "firebase/firestore";

import { FIREBASE_CONFIG, FIREBASE_EVENT_CATEGORY, FIREBASE_LOG_EVENTS } from "../constants/FirebaseConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";

const app = initializeApp(JSON.parse(FIREBASE_CONFIG));

const db = FIREBASE_LOG_EVENTS ? getFirestore(app) : null;

const extractParams = (params) => {
    let category = params.length === 3 ? params[0] : null;
    let key = params[params.length === 3 ? 1 : 0];
    let value = params[params.length === 3 ? 2 : 1];

    return { category, key, value };
};

const generateLogObj = (category, key, value) => {
    const dateTime = +new Date().getTime();
    const timestamp = Math.floor(dateTime / 10);
    key = timestamp + "_" + key;
    let obj = { [key]: value };
    if (category) {
        obj = { [category]: obj };
    }

    return obj;
};

export const LogFirebase = async (...params) => {
    if (FIREBASE_LOG_EVENTS) {
        let { category, key, value } = extractParams(params);
        if (category === FIREBASE_EVENT_CATEGORY.DeviceDetails && !PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
            /* Do not log for DeviceDetail category and 
                also if LD flag for capture-device-and-google-event is false */
            console.log("::DO NOT LOG DEVICE-DETAILS");
            return;
        }

        if (!CALL_DATA.memberId?.toString()) {
            /* prevent when someone tries to add log before call connected */
            console.log(key + " Logs can't be added - MemberId doesn't exist");
            return;
        }

        if (db) {
            const obj = generateLogObj(category, key, value);

            try {
                const document = doc(db, "showme_sessions", GLOBAL_MEETING_DATA.sessionId, "participants", CALL_DATA.memberId.toString());
                await setDoc(document, obj, { merge: true });
            } catch (error) {
                console.error(error);
            }
        }
    }
};

export const addClearFireBaseDBTime = async function () {
    // Calculate the date 1 month from now
    const futureDate = new Date();
    futureDate.setMonth(futureDate.getMonth() + 1);

    // Convert to Firestore Timestamp
    const futureTimestamp = Timestamp.fromDate(futureDate);
    const expireData = { expireAt: futureTimestamp };

    if (FIREBASE_LOG_EVENTS) {
        if (db) {
            if (!CALL_DATA.memberId) {
                //prevent when someone tries to add log before call connected
                console.error("Logs can't be added - MemberId doesn't exist");
            } else {
                try {
                    // Add expireAt to both session and participant documents
                    const sessionDocument = doc(db, "showme_sessions", GLOBAL_MEETING_DATA.sessionId);
                    const participantDocument = doc(
                        db,
                        "showme_sessions",
                        GLOBAL_MEETING_DATA.sessionId,
                        "participants",
                        CALL_DATA.memberId.toString()
                    );

                    await Promise.all([
                        setDoc(sessionDocument, expireData, { merge: true }),
                        setDoc(participantDocument, expireData, { merge: true }),
                    ]);
                } catch (error) {
                    console.error(error);
                }
            }
        }
    }
};
